import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData } from "@/lib/api-response";
import { downloadAuthenticatedFile } from "@/lib/download-blob";
import type {
  AuditLog,
  ExportAuditLogsQuery,
  ListAuditLogsQuery,
} from "@/types/audit-log";
import type { PaginatedResult } from "@/types/common";

interface AuditLogPagination {
  page: number;
  pageSize: number;
  total: number;
  pageCount: number;
}

const EMPTY_META = { total: 0, page: 1, limit: 25, totalPages: 1 };

export const auditLogService = {
  async list(
    query?: ListAuditLogsQuery,
  ): Promise<PaginatedResult<AuditLog>> {
    const response = await http.get(API_ENDPOINTS.AUDIT_LOGS.LIST, {
      params: query,
    });
    const data = unwrapData<{ items?: AuditLog[]; pagination?: AuditLogPagination }>(
      response,
    );
    const items = Array.isArray(data?.items) ? data.items : [];
    const pagination = data?.pagination;
    return {
      items,
      meta: pagination
        ? {
            total: pagination.total,
            page: pagination.page,
            limit: pagination.pageSize,
            totalPages: pagination.pageCount,
          }
        : EMPTY_META,
    };
  },

  async get(id: string): Promise<AuditLog> {
    const response = await http.get(API_ENDPOINTS.AUDIT_LOGS.DETAIL(id));
    return unwrapData<AuditLog>(response);
  },

  async exportCsv(query?: ExportAuditLogsQuery): Promise<void> {
    await downloadAuthenticatedFile(
      API_ENDPOINTS.AUDIT_LOGS.EXPORT,
      query,
      "audit-logs.csv",
    );
  },
};
